import { render, staticRenderFns } from "./ShapeMannequin.vue?vue&type=template&id=6f06eac2&scoped=true&"
import script from "./ShapeMannequin.vue?vue&type=script&lang=js&"
export * from "./ShapeMannequin.vue?vue&type=script&lang=js&"
import style0 from "./ShapeMannequin.vue?vue&type=style&index=0&id=6f06eac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06eac2",
  null
  
)

export default component.exports